import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useState } from 'react';
import axios from 'axios';
import { API_ENDPOINT } from '../constants/constants';
import { saveToken } from '../utils/util'

const Login = () => {
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false)

  const onSubmit = (e) => {
    e.preventDefault()
    axios.post(API_ENDPOINT + 'sam/login', { username, password }).then(res => {
      let d = res.data
      if (d.success) {
        saveToken(d.message.token)
        document.location.href = '/home'
      } else {
        toast(d.message)
      }
    })
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--color-bg)' }}>
      {/* LEFT — hero */}
      <div style={{ flex: 1, background: 'var(--color-accent)', color: 'var(--color-bg)', padding: '56px 56px 40px', display: 'flex', flexDirection: 'column', position: 'relative' }}>
        <div style={{ fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: 20, letterSpacing: '-0.01em' }}>TYK<span style={{ opacity: .7 }}> / ADMIN</span></div>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', maxWidth: 520 }}>
          <div style={{ fontSize: 12, letterSpacing: '0.14em', textTransform: 'uppercase', opacity: .75, marginBottom: 22 }}>Assessment control room</div>
          <h1 style={{ fontSize: 64, lineHeight: 0.98, color: 'var(--color-bg)', margin: '0 0 24px' }}>Run every test, trainer and plan from one grid.</h1>
          <p style={{ fontSize: 16, opacity: .85, maxWidth: 440, margin: 0 }}>The operator console for TestYourKnowledge — question banks, mock tests, memberships and audit trails in a single flat surface.</p>
        </div>
        <div style={{ display: 'flex', gap: 40, borderTop: '2px solid color-mix(in srgb, #ffffff 40%, transparent)', paddingTop: 20 }}>
          <div><div style={{ fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: 26 }}>8,640</div><div style={{ fontSize: 11, letterSpacing: '.1em', textTransform: 'uppercase', opacity: .8 }}>Tests run</div></div>
          <div><div style={{ fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: 26 }}>1,284</div><div style={{ fontSize: 11, letterSpacing: '.1em', textTransform: 'uppercase', opacity: .8 }}>Active trainers</div></div>
          <div><div style={{ fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: 26 }}>3,127</div><div style={{ fontSize: 11, letterSpacing: '.1em', textTransform: 'uppercase', opacity: .8 }}>Mock tests</div></div>
        </div>
      </div>

      {/* RIGHT — sign in */}
      <div style={{ width: 480, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '56px 56px' }}>
        <div style={{ fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: 15, letterSpacing: '.06em', textTransform: 'uppercase', color: 'var(--color-accent)' }}>Welcome back</div>
        <h2 style={{ fontSize: 34, margin: '8px 0 4px' }}>Sign in to Admin</h2>
        <p style={{ fontSize: 14 }} className="text-muted">Use your operator credentials.</p>
        <hr className="hr" />
        <form onSubmit={onSubmit}>
          <div className="field" style={{ marginBottom: 16 }}>
            <label>Username</label>
            <input className="input" type="text" value={username} onChange={e => setUsername(e.target.value)} required />
          </div>
          <div className="field" style={{ marginBottom: 8 }}>
            <label>Password</label>
            <div style={{ position: 'relative' }}>
              <input className="input" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} required style={{ paddingRight: 40 }} />
              <button type="button" onClick={() => setShowPassword(!showPassword)} aria-label="Toggle password visibility"
                style={{ position: 'absolute', right: 6, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 0, cursor: 'pointer', color: 'var(--color-neutral-500)', padding: 4, display: 'flex' }}>
                {showPassword
                  ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>
                  : <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/><line x1="2" x2="22" y1="2" y2="22"/></svg>}
              </button>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 18 }}>
            <a href="/reset-password" style={{ fontSize: 12 }}>Forgot password?</a>
          </div>
          <button type="submit" className="btn btn-primary btn-block" style={{ justifyContent: 'space-between', padding: '12px 16px' }}>
            Login
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
          </button>
        </form>
        <div style={{ marginTop: 'auto', paddingTop: 40, fontSize: 11 }} className="text-muted">TYK Admin · v3.2 · Internal use only</div>
      </div>
    </div>
  )
}
export default Login
